module.exports = __webpack_public_path__ + "img/nav_2.30bf32f6.png";